import { combineReducers } from 'redux';
import boxReducer from './box';
import campaignsReducer from './campaigns';
import growthReducer from './growth';
import layoutReducer from './layout';
import userReducer from './user';
import viewReducer from './view';

export default () =>
  combineReducers({
    box: boxReducer,
    layout: layoutReducer,
    user: userReducer,
    view: viewReducer,
    campaigns: campaignsReducer,
    growth: growthReducer,
  });
